"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M1 4h18c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1zm1 2v8h16V6H2z"];
//# sourceMappingURL=rectangle.js.map